export default {
  getRepairPoint(data){
    return {
      name: '维修服务网点',
      type: 'effectScatter',
      data: data,
      coordinateSystem: 'geo',
      //这里可以设置点的大小
      symbolSize: function (val) {
        return 5
      },
      showEffectOn: 'render', //高亮时显示特效
      rippleEffect: {
        brushType: 'stroke',
        scale: 6
      },
      hoverAnimation: false,
      itemStyle: {
        normal: {
          color: '#04B404' //地图点的颜色
        }
      },
      layoutCenter: ['50%', '50%'], //属性定义地图中心在屏幕中的位置，一般结合layoutSize 定义地图的大小
      layoutSize: 430
    }
  },

  getOperationCenter(data){
    return {
      name: '运营中心',
      type: 'effectScatter',
      data: data,
      coordinateSystem: 'geo',
      //这里可以设置点的大小
      symbolSize: function (val) {
        return 15
      },
      showEffectOn: 'render', //高亮时显示特效
      rippleEffect: {
        brushType: 'stroke',
        scale: 6
      },
      hoverAnimation: false,
      itemStyle: {
        normal: {
          color: '#FFFF00' //地图点的颜色
        }
      },
      layoutCenter: ['50%', '50%'], //属性定义地图中心在屏幕中的位置，一般结合layoutSize 定义地图的大小
      layoutSize: 430
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/board/options/series.js